import { combineReducers } from 'redux';

import globals from './globalsReducer';
import survey from './surveyReducer';
import test from './testReducer';

// combine reducers
const rootReducer = combineReducers({
    survey,
    globals,
    test
});

export default rootReducer;



// WEBPACK FOOTER //
// ./sources/js/reducers/rootReducer.js